var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9BA4C5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m8.746 8.891 6.508-2.531m-6.649 5.568 6.79 3.395M5.25 14a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5m13.5-5.25a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5m0 12a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5"
  })));
};
export default SvgShare;